import React from 'react';
import styled from 'styled-components';
import ImageRow from '../components/ImageRow';
import Layout from '../components/Layout';
import NoPageHero from '../components/404Hero';
import ContactForm from '../components/ContactForm';
// import Seo from '../components/Seo';
import { graphql } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';

const StyledErrorPage = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 4.5rem;
  margin-bottom: 3.5rem;
`;

const ErrorPage = ({ data }) => {
  return (
    <Layout CTA border>
      <StyledErrorPage>
        <NoPageHero />
        <ImageRow
          images={data.allPrismicWebinar.nodes.slice(0, 3).map((webinar) => {
            return {
              image: getImage(webinar.data.header_image?.gatsbyImageData)
                ? getImage(webinar.data.header_image?.gatsbyImageData)
                : 'https://images.prismic.io/bcvsocial/04247e7c-56ac-443d-91d8-113cb1e91444_191008_JW-Marriott-DC_GW_Pre-Selects-25-1-e1575570515666.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max',
              alt: webinar.data.header_image?.alt ? webinar.data.header_image?.url : 'Webinar',
              title: webinar.data.title,
              type: webinar.type,
              date: webinar.data.date_time,
              description: webinar.data.topics.text,
            };
          })}
        />
        <ContactForm />
      </StyledErrorPage>
    </Layout>
  );
};

export default ErrorPage;
// export const Head = ({ data }) => (
//   <Seo title={data.prismicMetadata.data.title.text}>
//     <meta name="description" content={data.prismicMetadata.data.description.text} />
//   </Seo>
// );

export const WebinarQuery = graphql`
  query Webinars {
    allPrismicWebinar {
      nodes {
        data {
          title
          date_time(formatString: "MMMM DD, YYYY")
          header_image {
            alt
            gatsbyImageData(placeholder: BLURRED, width: 800, height: 800)
          }
          topics {
            text
          }
        }
        type
      }
    }
    prismicMetadata(data: { page: { text: { eq: "404" } } }) {
      data {
        title {
          text
        }
        description {
          text
        }
      }
    }
  }
`;
